const keys = {
    GET_EXPLORE_POSTS: '/explore', // filters=[array of filter Id]
    GET_REELS_TOGGLE: (rId: string, type: string) => `/reels/toggle/${rId}/${type}`, // type = view , like , mark
    GET_REELS_FILTERS: '/reels/filters', //filters list
    GET_POST_TYPE: '/post-types',
    GET_CURRENT_PROGRAM_POST_TYPES: (page_id: string) => `/current-program-post-types/${page_id}`,
    GET_VIDEO_STYLES: '/video-styles',
    REEL_STATUS_UPDATE: (id: string, status: 'view' | 'like' | 'mark') => `/reels/toggle/${id}/${status}`
};

export default keys;

